import { Fragment } from 'react';
import { useLocation, Link } from 'react-router-dom';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CloseIcon } from 'assets/images/close-icon.svg';
import { useTranslation } from 'react-i18next';

const MenuDrawer = ({ open, toggleDrawer, list, activeSortBy }) => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <SwipeableDrawer
      anchor='bottom'
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      drawersmall='true'
    >
      <Box
        sx={{ width: 'auto' }}
        role='presentation'
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <List disablePadding>
          {list.map(({ text, icon, to, onClick, sortBy }, index) => (
            <Fragment key={`${text}-${index}`}>
              <ListItem disablePadding>
                <ListItemButton
                  component={to && Link}
                  to={to && location.pathname + to}
                  state={to && { background: location }}
                  onClick={onClick && onClick}
                  selected={sortBy && sortBy === activeSortBy ? true : false}
                >
                  <ListItemIcon>{icon}</ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
              <Divider component='li' />
            </Fragment>
          ))}
          <ListItem disablePadding>
            <ListItemButton
              sx={{ borderRadius: '0 0 24px 24px', overflow: 'hidden' }}
            >
              <ListItemIcon>
                <SvgIcon
                  component={CloseIcon}
                  svgstroke='true'
                  color='error.second'
                />
              </ListItemIcon>
              <ListItemText primary={t('action.close')} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </SwipeableDrawer>
  );
};

export default MenuDrawer;
